<div class="footer">
  <a (click)="openCookies()">
    {{ 'COOKIES.COOKIES_POLICY_LINK' | translate }}
  </a>
  ·
  <span>© {{ currentYear }} Mavie Work</span>
</div>